import { render } from "./ShipmentLabelDetail.vue?vue&type=template&id=0bd81ee3&ts=true"
import script from "./ShipmentLabelDetail.vue?vue&type=script&lang=ts"
export * from "./ShipmentLabelDetail.vue?vue&type=script&lang=ts"

import "./ShipmentLabelDetail.vue?vue&type=style&index=0&id=0bd81ee3&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__